import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import img1 from "../../assets/img/slider1.jpg";
import img2 from "../../assets/img/slider2.jpg";

const HeroSlider = () => {
  return (
    <section>
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        navigation={true}
        modules={[Navigation]}
      >
        <SwiperSlide>
          <div
            className="swiper-slide slide-hero"
            style={{ "background-image": `url(${img1})` }}
          >
            <div className="slider_text">
              <div className="title" data-swiper-parallax="-300">
                Welcome to Booze247 – Late Night Alcohol Delivery in Cardiff
              </div>
              <div className="subtitle" data-swiper-parallax="-200">
                Your go-to solution for fast, reliable, and convenient alcohol
                delivery, right when you need it – even after hours!
              </div>
              <div className="shop_btn">
                <Link to="/shop" type="button" className="Shop_Now">
                  Shop Now
                </Link>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className="swiper-slide slide-hero"
            style={{ "background-image": `url(${img2})` }}
          >
            <div className="slider_text">
              <div className="title" data-swiper-parallax="-300">
                Discover the Wine of Germany
              </div>
              <div className="subtitle" data-swiper-parallax="-200">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt
              </div>
              <div className="shop_btn">
                <button type="button" className="Shop_Now">
                  Shop Now
                </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default HeroSlider;
